import { AddressFormat } from '@bringg/types/types/merchant_configuration';
import { Translations as TaskNotesTranslations } from '../../components/task-notes/task-notes';
import { Translations as WayPointTimesTranslations } from '../../components/waypoint-times/waypoint-times';
import { Translations as CustomerContactTranslations } from '../../components/customer-contact/customer-contact';
import { Translations as TaskInventoriesTranslations } from '../../components/task-inventories/task-inventories';
import { Translations as TaskNotesAttachmentsTranslations } from '../../components/task-notes-attachments/task-notes-attachments';
import { Translations as WayPointCardFormTranslations } from './waypoint-card-form/waypoint-card-form';
import { Translations as TaskTrackingLinksTranslations } from '../../components/task-tracking-links/task-tracking-links';

export interface OrderPageConfiguration {
	permissions: OrderPagePermissions;
	flags: OrderPageFlags;
}
export interface OrderPagePermissions {
	edit: boolean;
	editInventoryQuantity: boolean;
	editDimension: boolean;
}
export interface OrderPageFlags {
	useTeamTimezone: boolean;
	addressFormat: AddressFormat;
}

export enum AddressKeys {
	ADDRESS = 'address',
	STREET = 'street',
	HOUSE_NUMBER = 'house_number',
	CITY = 'city',
	STATE = 'state',
	ZIPCODE = 'zipcode',
	LOCATION_NAME = 'location_name',
	BOROUGH = 'borough'
}

export interface TaskInventoriesFlagsAccess {
	enable_dispatcher_edit_task_inventory_quantity: boolean;
	enable_dimension_editing_in_ui: boolean;
}

export interface Translations
	extends TaskNotesTranslations,
		CustomerContactTranslations,
		WayPointTimesTranslations,
		TaskInventoriesTranslations,
		TaskNotesAttachmentsTranslations,
		WayPointCardFormTranslations,
		TaskTrackingLinksTranslations {
	notes: string;
	inventories: string;
	attachments: string;
	trackingLinks: string;
	editStop: string;
	of: string;
	stop: string;
	copyCoordinates: string;
	coordinatesCopied: string;
	canceled: string;
	fulfilled: string;
	partially_fulfilled: string;
}

export enum WaypointStatusClass {
	FULFILLED = 'fulfilled',
	CANCELED = 'canceled',
	PARTIALLY_FULFILLED = 'partially-fulfilled'
}

export interface WindowCommunicationService {
	isDev: () => boolean;
	messageHandler: (currentWindow, type, data) => (event) => void;
	sendCredentials: (currentWindow) => void;
	sendInitialData: (currentWindow, data) => void;
}
